import { stub } from '@pharmaplan/common/helpers/utils';
import { useFormik } from 'formik';

const useChatSearch = () => {
  const formik = useFormik({
    initialValues: {
      searchText: '',
      showSearch: false,
    },
    onSubmit: stub,
  });

  return { formik };
};

export default useChatSearch;
